import { render } from "./Teachers.vue?vue&type=template&id=52254cf0&scoped=true"
import script from "./Teachers.vue?vue&type=script&lang=js"
export * from "./Teachers.vue?vue&type=script&lang=js"

import "./Teachers.vue?vue&type=style&index=0&id=52254cf0&scoped=true&lang=css"

import exportComponent from "/Users/vncsalencar/Personal/Projects/araruna-anare-rollcall/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52254cf0"]])

export default __exports__